import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSemanticuireactComponent } from './simple-icons-semanticuireact.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSemanticuireactComponent ],
    exports:      [ SimpleIconsSemanticuireactComponent ],
    bootstrap:    []
})
export class SimpleIconsSemanticuireactModule {}
